import { catchError, tap } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { LobbyCheckIn } from '../models/lobby-check-in';
import { WrapUp } from '../../lobby-wrap-up/shared/models/wrap-up';
import { DeactivateLobbyEntries } from '../models/deactivate-lobby-entries';
import { LobbyEntryImpersonateDto } from '../models/lobby-entry-impersonate.dto';
import { ImpersonateTransferPostData } from '../models/impersonate-transfer-data';
import { ImpersonateTransferConfirmationPostData } from '../models/impersonation-transfer-confirmation-data';
import { ProvidedService } from '../models/lobby-entry-detail';
import { BackToLobby } from '../../lobby-wrap-up/shared/models/back-to-lobby';
import { EditLobbyComment } from 'src/app/shared/models/edit-lobby-comment';
import { Store } from "@ngrx/store";
import { getLoggedInUserInfo } from "src/app/state";
import { State } from "src/app/state/app.state";

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class LobbyEntryService {
  private baseUrl?: string;
  private apiController?: string;
  private appConfig?: AppConfigurations;
  private preferredLanguageId : number = 1;

  constructor(private http: HttpClient, private appInitService: AppInitService, private store: Store<State>) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }
  
  private _onReceiveAppConfig(appConfig: AppConfigurations){
    this.appConfig = appConfig;
    this.baseUrl = this.appConfig.lobbyApi.baseApiUrl;
    this.apiController = this.appConfig.lobbyApi.lobbyEntryController;
  }

    getPreferredLanguage() {
    this.store.select(getLoggedInUserInfo).subscribe((user) => {
      if (user !== undefined && user !== null && user['preferredLanguage']) {
        this.preferredLanguageId = user['preferredLanguage'];
      }
    }
    );
  }

  private get languageParam(): HttpParams {
      return new HttpParams().set('preferredLanguageId', this.preferredLanguageId.toString());
  }

  addToLobby(lobbyCheckIn: LobbyCheckIn): Observable<number> {
    return this.http.post<number>(`${this.baseUrl}${this.apiController}/checkin`, lobbyCheckIn)
      .pipe(
        tap(data => console.log('addToLobby: ' + data)),
        catchError(this.handleError)
      );
  }

  deactivateLobbyEntries(deactivateLobbyEntries: DeactivateLobbyEntries): Observable<number> {
    return this.http.patch<number>(`${this.baseUrl}${this.apiController}/deactivate`, deactivateLobbyEntries)
      .pipe(
        tap(data => console.log('deactivate: ' + data)),
        catchError(this.handleError)
      );
  }

  instantAssist(lobbyCheckIn: LobbyCheckIn, userId: number): Observable<number> {  
    return this.http.post<number>(`${this.baseUrl}${this.apiController}/instantassistby/${userId}`, lobbyCheckIn)
      .pipe(
        tap(data => console.log('instantAssist: ' + data)),
        catchError(this.handleError)
      );
  }
  
  impersonateInstantAssist(lobbyCheckIn: LobbyCheckIn, userId: number): Observable<number> { 
    return this.http.post<number>(`${this.baseUrl}${this.apiController}/impersonateInstantassistby/${userId}`, lobbyCheckIn)
      .pipe(
        tap(data => console.log('impersonateInstantAssist: ' + data)),
        catchError(this.handleError)
      );
  }

  setLWAReason(lobbyEntryId: number,signedInLocationId:number, reasonId: number, comment?: string, userId?: number): Observable<number> {
    let dataObject = { 'ReasonId': reasonId, 'Comment': comment, 'UserId': userId,'SignedInLocationId':signedInLocationId };
    return this.http.patch<number>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}/leftwithoutassist`, dataObject)
      .pipe(
        tap(data => console.log('leftwithoutassist: ' + data)),
        catchError(this.handleError)
      );
  }

  assist(lobbyEntryId: number, userId: number, locationId: any): Observable<number> {
    return this.http.patch<number>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}/assistby/${userId}?locationId=${locationId}`, {})
      .pipe(
        tap(data => console.log('assist: ' + data)),
        catchError(this.handleError)
      );
  }

  impersonateAssist(impersonateDto: LobbyEntryImpersonateDto): Observable<number> {
  if (impersonateDto!=null && impersonateDto) {
    return this.http.post<number>(`${this.baseUrl}${this.apiController}/user/impersonate`, impersonateDto)
      .pipe(
        catchError(this.handleError)
      );
  }
  
  return of(0);
}
  transferImpersonateAssist(transferimpersonateData: ImpersonateTransferPostData[]):Observable<number> {
   
      return this.http.post<number>(`${this.baseUrl}${this.apiController}/user/impersonatetransfer`, transferimpersonateData)
        .pipe(
          catchError(this.handleError)
        );
    
  }
  transferImpersonationConfirmation(transferimpersonationConfirmationData: ImpersonateTransferConfirmationPostData[]):Observable<number> {
   
    return this.http.post<number>(`${this.baseUrl}${this.apiController}/user/impersonatetransferconfirm`, transferimpersonationConfirmationData)
      .pipe(
        catchError(this.handleError)
      );
  
}
    
  


  sendTextOnDemand(lobbyEntryId: number, message: string, userId?: number) {
    let dataObject = { 'Message': message, 'UserId': userId };
    return this.http.patch<any>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}/ondemandtext`, dataObject)
      .pipe(
        tap(data => console.log('sendtextondemand: ' + data)),
        catchError(this.handleError)
      );
  }

  getLobbyEntryDetails(lobbyEntryId: number): Observable<any> {   
    this.getPreferredLanguage();
    return this.http.get<any>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}`,
      { params : this.languageParam }
    );
  }

  assistLobbyRecord(lobbyEntryId: number, assistingUserId: number): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}/assistby/${assistingUserId}`, {});
  }

  updateCheckin(lobbyEntryId: number, lobbyRecord: any): Observable<any> {
    console.log(`%c[Lobby Entry Edit]: EntryID: ${lobbyEntryId}, LobbyRecord: ${JSON.stringify(lobbyRecord)}`, 'color:rgb(255,100,44)')
    return this.http.put<any>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}/checkin`, lobbyRecord);
  }

  updateLobbyEntry(lobbyEntryId: number, lobbyRecord: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}/update`, lobbyRecord);
  }
  updateLobbyComment(lobbyEntryId: number, commentRecord: EditLobbyComment): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}/editcomment`, commentRecord);
  }

  backToLobby(backtolobbyData:BackToLobby) {
    return this.http.patch<any>(`${this.baseUrl}${this.apiController}/${backtolobbyData.lobbyEntryId}/backtolobby`, backtolobbyData);
  }

  provideService(lobbyEntryId: number, serviceId: number) {
    this.getPreferredLanguage();
    return this.http.patch<ProvidedService[]>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}/provideservice/${serviceId}`, 
      {}, // body
      { params: this.languageParam } // queryParams
    );
  }

  updateProvidedServiceReference(lobbyEntryId: number, serviceProvidedId: number, reference: string) {
    this.getPreferredLanguage();
    return this.http.patch<ProvidedService[]>(
      `${this.baseUrl}${this.apiController}/${lobbyEntryId}/providedservice/${serviceProvidedId}/setreference`,
      { referenceNumber: reference },
      { params: this.languageParam }
    );
  }

  removeProvidedService(lobbyEntryId: number, serviceProvidedId: number) {
    this.getPreferredLanguage();
    return this.http.delete<ProvidedService[]>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}/removeprovidedservice/${serviceProvidedId}`,
      { params: this.languageParam }
    );
  }

  wrapUp(wrapUpData: WrapUp) {
    return this.http.patch<any>(`${this.baseUrl}${this.apiController}/wrapup`, wrapUpData);
  }

  updateRemoteCheckInStatus(lobbyEntryId: number, isArrived: boolean) {
    return this.http.put<any>(`${this.baseUrl}${this.apiController}/${lobbyEntryId}/arrived/${isArrived}`, null);
  }
 

  private handleError(err: any) {
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `${err.error}`;
    }
    console.error(err);
    return throwError(errorMessage);
  }

}
